import React from "react";
import { Link } from "react-router-dom";
import styles from "./Home.scss";
import Modal from "../../../components/common/modal/Modal";
import classNames from "classnames";
import projectIcon from "../../../assets/images/home-project-icon.svg";
import verifyIcon from "../../../assets/images/home-verify-icon.svg";
import readIcon from "../../../assets/images/home-read-icon.svg";
import arrow from "../../../assets/images/home-arrow.svg";

class Home extends React.Component {
  constructor() {
    super();

    this.state = {
      showModal: false
    };
  }

  toggleModal() {
    this.setState(prevState => {
      return { showModal: !prevState.showModal };
    });
  }

  isVerified() {
    const verified = localStorage.getItem("verified");
    return verified === "true";
  }

  render() {
    return (
      <section className={styles.onBoarding}>
        <div className={styles.mainContainer}>
          <div className={styles.leftContainer}>
            <div>
              <h1>You’re in.</h1>
              <div className={styles.subtitle}>Let’s get to work.</div>
            </div>

            <div className={styles.dividerDouble} />

            <div className={styles.listTitle}>
              The Second Shift works like this:
            </div>
            <ul>
              <li>
                You post your project, including title, description, timeline
                and budget.
              </li>
              <li>
                We auto-match projects with pre-vetted candidates who meet your
                skill requirements.
              </li>
              <li>
                You select the best candidates among the ones who pitch you.
              </li>
              <li>Your top candidates submit proposals.</li>
              <li>You pick your favorite, and she gets to work.</li>
            </ul>

            <Link to="#">
              <div className={styles.learnMore}>Learn more ›</div>
            </Link>
          </div>

          <div className={styles.rightContainer}>
            <div className={styles.subtitle}>Here’s how to get going:</div>

            <Link to="/company/project/create" className={styles.link}>
              <div className={classNames(styles.rectangle, styles.first)}>
                <div className={styles.imgTextContainer}>
                  <img src={projectIcon} className={styles.icon} />
                  <div className={styles.textContainer}>
                    <div className={styles.title}>Post a Project</div>
                    <div className={styles.subtitle}>
                      Start here! Create a project to be matched algorithmically
                      with the most qualified candidates.
                    </div>
                  </div>
                </div>
                <img src={arrow} />
              </div>
            </Link>

            {this.isVerified() ? (
              <div>
                <div
                  className={classNames(
                    styles.rectangle,
                    styles.second,
                    styles.disabled
                  )}
                >
                  <div className={styles.imgTextContainer}>
                    <img src={verifyIcon} className={styles.icon} />
                    <div className={styles.textContainer}>
                      <div className={styles.title}>Verify Your Account</div>
                      <div className={styles.subtitle}>
                        Before you can post a project, we need to make sure
                        you’re legit. Complete this step to save time later.
                      </div>
                    </div>
                  </div>
                  <img src={arrow} />
                </div>
              </div>
            ) : (
              <Link to="verify-account" className={styles.link}>
                <div className={classNames(styles.rectangle, styles.second)}>
                  <div className={styles.imgTextContainer}>
                    <img src={verifyIcon} className={styles.icon} />
                    <div className={styles.textContainer}>
                      <div className={styles.title}>Verify Your Account</div>
                      <div className={styles.subtitle}>
                        Before you can post a project, we need to make sure
                        you’re legit. Complete this step to save time later.
                      </div>
                    </div>
                  </div>
                  <img src={arrow} />
                </div>
              </Link>
            )}

            <a
              href="#"
              className={styles.link}
              onClick={() => {
                this.toggleModal();
              }}
            >
              <div className={styles.rectangle}>
                <div className={styles.imgTextContainer}>
                  <img src={readIcon} className={styles.icon} />
                  <div className={styles.textContainer}>
                    <div className={styles.title}>Read More: How We Work</div>
                    <div className={styles.subtitle}>
                      What we do, who we are, what we stand for.
                    </div>
                  </div>
                </div>
                <img src={arrow} />
              </div>
            </a>

            {this.state.showModal && (
              <Modal
                title="How it Works"
                onHide={() => {
                  this.toggleModal();
                }}
              />
            )}
          </div>
        </div>
      </section>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/routes/employer/home/Home.js